// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.
// This route is for the pages that can be accessed by public but not logged in users like Sign In.

// If they are: they proceed to the page
// If not: they are redirected to the home page.
import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { getToken, logout } from '../../services/User';

const UserRestrictedRoute = ({ component: Component, alternate: Alternate, ...rest }) => {

  // Add your own authentication on the below line.
  function checkLogin() {

    const xToken = getToken();

    if (!xToken) {
      return false;
    }
    return true;
  }
  const isLoggedIn = checkLogin();

  const originalUrl = document.location.pathname;

  return (
    <Route
      {...rest}
      render={props =>
        isLoggedIn ? (
          Alternate ? <Alternate {...props} /> :
            <Redirect to={{ pathname: `/` }} />
        ) : (
          <Component {...props} />
        )
      }
    />
  )
}

export default UserRestrictedRoute